/* eslint-disable eqeqeq */
import { useDispatch, useSelector } from "react-redux";
import DispositionPenalty from "./DispositionPenaltyFee"
import { useCallback, useEffect, useRef, useState } from "react";
import GridDataFiltersAction from "Store/Component/GridDataFilters/GridDataFiltersAction";
import { useDebounce } from "client/CommonComponents/CustomDebounce/DebounceHook";
import moment from "moment";
import { getDispositionEquipmentClass, getDispositionPenaltyFeeGridData, getDispositionType } from "Store/OrderManagement/DispositionPenaltyFee/DispositionPenaltyFeeAction";
import { getCostCenterList, getRequestedByList, getStatusList, getUpdatedByList } from "Store/OrderManagement/OrderGridDropdowns/OrderGridDropdownsAction";
import { CustomDateFilterComponent, CustomDropdownFilterComponent } from "../../BulkOrder/Home/HomeHelper";
import { COLUMN_FILTERS } from "client/utils/constants/homeGridConstants";
import { GetOnOrderIdClickedUrl } from "../../mainUtil";
import { useNavigate } from "react-router-dom";
import { CONSTANTS } from "client/utils/constants";
import navOperations from "redux/Navigation/operations";
import { commonExportExcel, fetchGridPayload } from "utils";

const DispositionPenaltyContainer = () => {
    const breadcrumlist = [
        { text: 'Reports', key: 'f1', href: '/ordermanagement', onClick: (e: any) => { e.preventDefault();}}, {}
      ]

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const dispatchNav = navOperations.dispatchNav(dispatch);
    const dispatchHeaderNav = navOperations.dispatchHeaderNav(dispatch);

    const [paginationData, setPaginationData] = useState<any>({})
    const [pagesCount, setPagesCount] = useState<number>(0)
    const [serverTotal, setServerTotal] = useState(0)
    const [sortData, setSortData] = useState<any>('')
    const [searchValue, setSearchValue] = useState('')
    const [dateRange, setDateRange] = useState<any>([]);
    const [gridData, setGridData] = useState([])
    const [showGrid, setShowGrid] = useState<boolean>(false)

    const createdDate = useRef<any>(null);
    const updatedDate = useRef<any>(null);
    const selectCostCenter = useRef("");
    const selectEquipmentClass = useRef('');
    const selectDispositionType = useRef('');
    const selectCreatedBy = useRef("");
    const selectUpdatedBy = useRef('');
    const selectStatus = useRef("");
    const selectPenaltyExemption = useRef("");
    const [orderIdFilter, setOrderIdFilter] = useState<any>('')
    const [assetNumberFilter, setAssetNumberFilter] = useState<any>('')
    const [penaltyFeesFilter, setPenaltyFeesFilter] = useState<any>('')
    const [penaltyExemptionCommentFilter, setPenaltyExemptionCommentFilter] = useState<any>('')
    const [netBookedValueFilter, setNetBookedValueFilter] = useState<any>('')
  
    const updatedByDropdownList: any = useRef(null);
    const createdByDropdownList: any = useRef(null)
    const costCenterDropdownList: any = useRef(null);
    const equipmentClassDropdownList: any = useRef(null)
    const dispositionTypeDropdownList: any = useRef(null)
    const statusDropdownList: any = useRef(null)
    const penaltyExemptionDropdownList = [{label: 'Yes', value: 'true', text: 'Yes'}, {label: 'No', value: 'false', test: 'No'}]

    const {
        dispositionPenaltyFeeGridData,
        dispositionPenaltyFeesGridFilters,
        costCenterList,
        requestedByList,
        updatedByList,
        dispositionEquipmentClassList,
        dispositionTypeList,
        statusList
      }: any = useSelector(
        (state: any) => ({
          dispositionPenaltyFeeGridData: state.DispositionPenaltyFeeReducer.dispositionPenaltyFeeGridData,
          dispositionPenaltyFeesGridFilters: state.GridFiltersReducer.dispositionPenaltyFeesGridFilters,
          costCenterList: state.OrderGridDropdownsReducer.costCenterList,
          requestedByList: state.OrderGridDropdownsReducer.requestedByList,
          updatedByList: state.OrderGridDropdownsReducer.updatedByList,
          dispositionEquipmentClassList: state.DispositionPenaltyFeeReducer.dispositionEquipmentClassList,
          dispositionTypeList: state.DispositionPenaltyFeeReducer.dispositionTypeList,
          statusList: state.OrderGridDropdownsReducer.statusList,
        })
      )
    
    useEffect(() => {
      !(costCenterList?.length > 0) && dispatch(getCostCenterList())
      !(requestedByList?.length > 0) && dispatch(getRequestedByList())
      !(updatedByList?.length > 0) && dispatch(getUpdatedByList())
      !(dispositionEquipmentClassList?.length > 0) && dispatch(getDispositionEquipmentClass())
      !(dispositionTypeList?.length > 0) && dispatch(getDispositionType())
      !(statusList?.length > 0) && dispatch(getStatusList())
    }, [])

    useEffect(() => {
      setShowGrid(true);
      setSearchValue(dispositionPenaltyFeesGridFilters?.orderSearchBoxValue || '');
      if (dispositionPenaltyFeesGridFilters?.dateRange?.length) {
        setDateRange(dispositionPenaltyFeesGridFilters?.dateRange)
      } else {
        setDateRange([]);
      }
      selectPenaltyExemption.current = dispositionPenaltyFeesGridFilters?.isRequestWriteOffPentaltyExemption ?? '' 
      selectStatus.current = dispositionPenaltyFeesGridFilters?.status ?? '';
      selectCreatedBy.current = dispositionPenaltyFeesGridFilters?.dispositionCreatedBy ?? '';
      selectCostCenter.current = dispositionPenaltyFeesGridFilters?.costCenter ?? '';
      selectUpdatedBy.current = dispositionPenaltyFeesGridFilters?.dispositionUpdatedBy ?? '';
      selectEquipmentClass.current = dispositionPenaltyFeesGridFilters?.eqClass ?? '';
      selectDispositionType.current = dispositionPenaltyFeesGridFilters?.dispositionType ?? ''
      createdDate.current = dispositionPenaltyFeesGridFilters?.dispositionCreatedDate ? new Date(dispositionPenaltyFeesGridFilters?.dispositionCreatedDate) : null;
      updatedDate.current = dispositionPenaltyFeesGridFilters?.dispositionUpdatedDate ? new Date(dispositionPenaltyFeesGridFilters?.dispositionUpdatedDate) : null;
    }, [])
    
    useEffect(() => {
      if (dispositionPenaltyFeeGridData?.data?.length) {
        const updatedOrderList = dispositionPenaltyFeeGridData?.data?.map((item: any) => ({
          ...item,
          dispositionCreatedDate: moment(item.dispositionCreatedDate).format("MM/DD/YYYY"),
          dispositionUpdatedDate: moment(item.dispositionUpdatedDate).format("MM/DD/YYYY"),
          isRequestWriteOffPentaltyExemption: item.isRequestWriteOffPentaltyExemption ? 'Yes' : 'No' 
        }));
        setGridData(updatedOrderList);
      } else {
        setGridData([]);
      }
      setServerTotal(dispositionPenaltyFeeGridData?.totalRecords)
    }, [dispositionPenaltyFeeGridData])

    useEffect(() => {
      setOrderIdFilter(dispositionPenaltyFeesGridFilters?.orderRequestId)
    }, [dispositionPenaltyFeesGridFilters?.orderRequestId])

    useEffect(() => {
      setAssetNumberFilter(dispositionPenaltyFeesGridFilters?.assetNumber)
    }, [dispositionPenaltyFeesGridFilters?.assetNumber])

    useEffect(() => {
      setPenaltyFeesFilter(dispositionPenaltyFeesGridFilters?.dispositionPenaltyFee)
    }, [dispositionPenaltyFeesGridFilters?.dispositionPenaltyFee])

    useEffect(() => {
      setPenaltyExemptionCommentFilter(dispositionPenaltyFeesGridFilters?.penaltyExemptionReason)
    }, [dispositionPenaltyFeesGridFilters?.penaltyExemptionReason])

    useEffect(() => {
      setNetBookedValueFilter(dispositionPenaltyFeesGridFilters?.netBookedValue)
    }, [dispositionPenaltyFeesGridFilters?.netBookedValue])

    useEffect(() => {
      const dropdownList: any = costCenterList?.map((item: any) => {
        return { label: item.text, key: item.value, ...item }
      })
      costCenterDropdownList.current = dropdownList
    }, [costCenterList])

    useEffect(() => {
      const dropdownList: any = requestedByList?.map((item: any) => {
        return { label: item.text, key: item.value, ...item }
      })
      createdByDropdownList.current = dropdownList
    }, [requestedByList])
    
    useEffect(() => {
      const dropdownList: any = dispositionEquipmentClassList?.map((item: any) => {
        return { label: item.text, key: item.value, ...item }
      })
      equipmentClassDropdownList.current = dropdownList
    }, [dispositionEquipmentClassList])

    useEffect(() => {
      const dropdownList: any = dispositionTypeList?.map((item: any) => {
        return { label: item.text, key: item.value, ...item }
      })
      dispositionTypeDropdownList.current = dropdownList
    }, [dispositionTypeList])

    useEffect(() => {
      const dropdownList: any = updatedByList?.map((item: any) => {
        return { label: item.text, key: item.value, ...item }
      })
      updatedByDropdownList.current = dropdownList
    }, [updatedByList])

    useEffect(() => {
      const dropdownList: any = statusList?.map((item: any) => {
        return { label: item.text, key: item.value, ...item }
      })
      statusDropdownList.current = dropdownList
    }, [statusList])

    const onSearchOrder = (e: any, isKeyPress?: any) => {
        setSearchValue((isKeyPress ? e : e?.target?.value))
        dispatch(GridDataFiltersAction.setDispositionPenaltyFeesFilters({ orderSearchBoxValue: (isKeyPress ? e : e?.target?.value)}))
    }

    const onDateRangeChange = (e: any) => {
        setDateRange(e);
        dispatch(GridDataFiltersAction.setDispositionPenaltyFeesFilters({ dateRange: e }))
    }

  const clear = {
    orderRequestId: '',
    costCenter: '',
    assetNumber: '',
    eqClass: '',
    dispositionType: '',
    dispositionPenaltyFee: '',
    isRequestWriteOffPentaltyExemption: '',
    penaltyExemptionReason: '',
    netBookedValue: '',
    status: '',
    dispositionCreatedDate: null,
    dispositionCreatedBy: '',
    dispositionUpdatedDate: null,
    dispositionUpdatedBy: '',
    orderSearchBoxValue: '',
    dateRange: []
  }

    const handleFilterClear = () => {
      setShowGrid(false);
      setSearchValue('')
      setDateRange([])
      createdDate.current = null
      updatedDate.current = null
      selectStatus.current = ''
      selectCreatedBy.current = ''
      selectCostCenter.current = ''
      selectEquipmentClass.current = ''
      selectDispositionType.current = ''
      selectUpdatedBy.current = ''
      selectPenaltyExemption.current = ''
      
      dispatch(GridDataFiltersAction.setDispositionPenaltyFeesFilters(clear));
      setTimeout(() => {
        setShowGrid(true);
      })
    }

    const onOrderIdClicked = (e: any, row: any) => {
      e.preventDefault();
      let orderId = row?.rowData?.orderRequestId;
      const orderStatus = row?.rowData?.status
      let navigationUrl = "";
      navigationUrl = GetOnOrderIdClickedUrl(orderStatus, CONSTANTS.DISPOSITION, orderId, false, 'asset', '')
      navigate(navigationUrl);
    };

    const setFilters = (value: any) => {
        if (JSON.stringify(value) !== '{}') {
            dispatch(GridDataFiltersAction.setDispositionPenaltyFeesFilters(value))
        }
    }

    const getFilteredValues = () => {
      let filteredValues: any = [];
      if (createdDate.current != null) {
        filteredValues.push({ 'field': 'dispositionCreatedDate', 'value': moment(new Date(createdDate.current)).format('YYYY-MM-DD') })
      }
      if (updatedDate.current != null) {
        filteredValues.push({ 'field': 'dispositionUpdatedDate', 'value': moment(new Date(updatedDate.current)).format('YYYY-MM-DD') })
      }
      if (selectStatus.current != "") {
        filteredValues.push({ 'field': COLUMN_FILTERS.STATUS, 'value': selectStatus.current })
      }
      if (selectCreatedBy.current != "") {
        const findValue = createdByDropdownList?.current?.find((item: any) => item.label === selectCreatedBy.current)
        filteredValues.push({ 'field': 'dispositionCreatedBy', 'value': findValue?.label })
      }
      if (selectUpdatedBy.current != "") {
        const findValue = updatedByDropdownList?.current?.find((item: any) => item.label === selectUpdatedBy.current)
        filteredValues.push({ 'field': 'dispositionUpdatedBy', 'value': findValue?.label })
      }
      if (selectDispositionType.current != "") {
        const findValue = dispositionTypeDropdownList?.current?.find((item: any) => item.label === selectDispositionType.current)
        filteredValues.push({ 'field': 'dispositionType', 'value': findValue?.value })
      }
      if (selectEquipmentClass.current != "") {
        filteredValues.push({ 'field': 'eqClass', 'value': selectEquipmentClass.current })
      }
      if (selectCostCenter.current != "") {
        const findValue = costCenterDropdownList?.current?.find((item: any) => item.label === selectCostCenter.current)
        filteredValues.push({ 'field': COLUMN_FILTERS.COST_CENTER, 'value': findValue?.value })
      }
      if (orderIdFilter != "" && orderIdFilter) {
        filteredValues.push({ 'field': 'orderId', 'value': orderIdFilter })
      }
      if (assetNumberFilter != "" && assetNumberFilter) {
        filteredValues.push({ 'field': 'assetNumber', 'value': assetNumberFilter })
      }
      if (penaltyFeesFilter != "" && penaltyFeesFilter) {
        filteredValues.push({ 'field': 'dispositionPenaltyFee', 'value': penaltyFeesFilter })
      }
      if (penaltyExemptionCommentFilter != "" && penaltyExemptionCommentFilter) {
        filteredValues.push({ 'field': 'penaltyExemptionComment', 'value': penaltyExemptionCommentFilter })
      }
      if (netBookedValueFilter != "" && netBookedValueFilter) {
        filteredValues.push({ 'field': 'netBookedValue', 'value': netBookedValueFilter })
      }
      if (selectPenaltyExemption.current != "") {
        const findValue = penaltyExemptionDropdownList?.filter((item: any) => item.label === selectPenaltyExemption.current)
        filteredValues.push({ 'field': 'isRequestWriteOffPenaltyExemption', 'value': findValue[0].value })
      }
      return filteredValues;
    }

    useEffect(() => {
        if (serverTotal && paginationData?.pageSize) {
          let pageSize = paginationData?.pageSize
          let tempPageCount = serverTotal > pageSize ? Math.ceil(serverTotal / pageSize - 1) : 0
          setPagesCount(tempPageCount)
        }
    }, [serverTotal, paginationData?.pageSize])

    const debounceObject = [
        paginationData, searchValue, dateRange, sortData, selectCostCenter, orderIdFilter, assetNumberFilter, selectEquipmentClass, 
        selectDispositionType, penaltyFeesFilter, penaltyExemptionCommentFilter, netBookedValueFilter, selectCreatedBy, selectUpdatedBy,
        createdDate, updatedDate, selectStatus, selectPenaltyExemption 
      ]
      const globalDebounce = useDebounce(debounceObject, 500)
    
      useEffect(() => {
        let payload: any = {
          "pageNumber": paginationData?.pageIndex != undefined ? paginationData?.pageIndex + 1 : undefined,
          "pageSize": paginationData?.pageSize,
          "columnFilters": getFilteredValues(),
        }
    
        payload = fetchGridPayload(payload, dateRange, searchValue, sortData, false, null)
    
    
        if (payload.pageNumber && payload.pageSize) {
          dispatch(getDispositionPenaltyFeeGridData(payload));
        }
      }, [globalDebounce])
    
      const fetchAction = useCallback((fetchData: any) => {
        if (fetchData.action && fetchData.action === "paging") {
          setPaginationData(fetchData.data)
        }
        if (fetchData.action && fetchData.action === "sorting") {
          setSortData(fetchData.data[0]);
        }
      }, [])

      const reportsColumns = [
        {
            key: "orderRequestId",
            title: "LEADR Order #",
            width: 60,
            filterRowValue: dispositionPenaltyFeesGridFilters?.orderRequestId ?? '',
            Cell: (row: any) => {
                return (
                  <a
                    href="/"
                    onClick={(e: any) => {
                      onOrderIdClicked(e, row);
                    }}
                    className="order-link-id"
                  >
                    {row.rowData.status === "Unsubmitted"
                      ? "Draft"
                      : row.rowData.orderRequestId}
                  </a>
                );
              },
        },
        {
            key: "costCenter",
            title: "Cost Center",
            width: 130,
            FilterCell: (props: any) => (
              <CustomDropdownFilterComponent {...props} options={costCenterDropdownList.current} setDropdown={selectCostCenter} />
            )
        },
        {
            key: "assetNumber",
            title: "Asset #",
            width: 100,
            filterRowValue: dispositionPenaltyFeesGridFilters?.assetNumber ?? ''
        },
        {
            key: "eqClass",
            title: "Equipment Class",
            width: 130,
            FilterCell: (props: any) => (
              <CustomDropdownFilterComponent {...props} options={equipmentClassDropdownList.current} setDropdown={selectEquipmentClass} />
            )
        },
        {
            key: "dispositionType",
            title: "Type of Disposition",
            width: 140,
            FilterCell: (props: any) => (
              <CustomDropdownFilterComponent {...props} options={dispositionTypeDropdownList.current} setDropdown={selectDispositionType} />
            )
        },
        {
            key: "dispositionPenaltyFee",
            title: "Penalty Fees",
            width: 130,
            Cell: (row: any) => {
              return (
                <p>
                  {'$ ' + row.rowData.dispositionPenaltyFee}
                </p>
              );
            },
            filterRowValue: dispositionPenaltyFeesGridFilters?.dispositionPenaltyFee ?? ''
        },
        {
            key: "isRequestWriteOffPentaltyExemption",
            title: "Penalty Exemption Request",
            width: 160,
            FilterCell: (props: any) => (
              <CustomDropdownFilterComponent {...props} options={penaltyExemptionDropdownList} setDropdown={selectPenaltyExemption} />
            )
        },
        {
            key: "penaltyExemptionReason",
            title: "Penalty Exemption Comment",
            width: 160,
            filterRowValue: dispositionPenaltyFeesGridFilters?.penaltyExemptionReason ?? ''
        },
        {
            key: "netBookedValue",
            title: "Net Booked value",
            width: 140,
            filterRowValue: dispositionPenaltyFeesGridFilters?.netBookedValue ?? ''
        },
        {
            key: "status",
            title: "Disposition Fleet Status",
            width: 130,
            FilterCell: (props: any) => (
              <CustomDropdownFilterComponent {...props} options={statusDropdownList.current} setDropdown={selectStatus} />
            )
        },
        {
            key: "dispositionCreatedDate",
            title: "Disposition Created Date",
            width: 160,
            FilterCell: (props: any) => (<CustomDateFilterComponent {...props} setDate={createdDate} />)
        },
        {
            key: "dispositionCreatedBy",
            title: "Disposition Created By",
            width: 160,
            FilterCell: (props: any) => (
              <CustomDropdownFilterComponent {...props} options={createdByDropdownList.current} setDropdown={selectCreatedBy} />
            )
        },
        {
            key: "dispositionUpdatedDate",
            title: "Disposition Updated Date",
            width: 160,
            FilterCell: (props: any) => (<CustomDateFilterComponent {...props} setDate={updatedDate} />)
        },
        {
            key: "dispositionUpdatedBy",
            title: "Disposition Updated By",
            width: 160,
            FilterCell: (props: any) => (
              <CustomDropdownFilterComponent {...props} options={updatedByDropdownList.current} setDropdown={selectUpdatedBy} />
            )
        }
    ]

    const onExportExcel = () => {
      if (gridData) {
        let dataTable: any[] = [];
        let columnHeaders: any[] = [];
        gridData.forEach((item: any) => {
          let excelData: any = {};
          reportsColumns.forEach((colDef: any) => {
            if (colDef?.title != 'Action') {
              const colName = colDef?.title;
              const key = colDef?.key;
              excelData[colName] = item[key] ?? '';
              if (columnHeaders.length != Object.keys(gridData).length) {
                columnHeaders.push(colName);
              }
            }
          });
          dataTable.push(excelData);
        });
        commonExportExcel(dataTable, columnHeaders, 'DispositionPenaltyFee', 'DispositionPenaltyFee.xlsx')
      }
    }

    const handleClickBack = (e?: any) => {
      e.preventDefault();
      dispatchHeaderNav("Reports");
      dispatchNav("Reports");
      navigate('/ordermanagement');
    }

  const alreadyHasGridFilterValues = useCallback(() => {
    let isAlreadyHasValues = true
    let GridFilterValueTemp = dispositionPenaltyFeesGridFilters
    Object.keys(clear)?.forEach((filterItem?: any) => {
      Object.keys(GridFilterValueTemp ?? {})?.forEach((gridItem?: any) => {
        if (filterItem == gridItem) {
          let val = gridItem
          if (val == "globalStatus") {
            if (GridFilterValueTemp[val]?.label != "All" && GridFilterValueTemp[val] != null && GridFilterValueTemp[val] != undefined && GridFilterValueTemp[val] != '') {
              isAlreadyHasValues = false
            }
          } else if (GridFilterValueTemp[val] != "" && GridFilterValueTemp[val] != null && GridFilterValueTemp[val] != undefined && val != "dateRange" && val != "globalStatus") {
            isAlreadyHasValues = false
          } else if (val == "dateRange") {
            if (GridFilterValueTemp[val]?.length) {
              isAlreadyHasValues = false
            }
          }
        }
      })
    })
    return isAlreadyHasValues
  }, [dispositionPenaltyFeesGridFilters])

    return(
        <DispositionPenalty 
            breadcrumlist={breadcrumlist}
            gridData={gridData}
            searchValue={searchValue}
            dateRange={dateRange}
            onSearchOrder={onSearchOrder}
            onDateRangeChange={onDateRangeChange}
            setFilters={setFilters}
            serverTotal={serverTotal}
            fetchAction={fetchAction}
            pagesCount={pagesCount}
            reportsColumns={reportsColumns}
            handleFilterClear={handleFilterClear}
            showGrid={showGrid}
            onExportExcel={onExportExcel}
            handleClickBack = {handleClickBack}
            alreadyHasGridFilterValues = {alreadyHasGridFilterValues}
        />
    )
}

export default DispositionPenaltyContainer